// Times as people type them (Back office sweep, Oct 2026: D8). "1830" is 18:30, "830" is
// 08:30, "18" is 18:00, "6pm" is 18:00, "18.30" and "18:3" are 18:30. Anything that isn't a
// time of day is null, so the field can keep what it had.

export function parseTime(text) {
  const raw = String(text ?? '').trim().toLowerCase().replace(/\s+/g, '');
  if (!raw) return null;
  const pm = /pm$/.test(raw);
  const am = /am$/.test(raw);
  const body = raw.replace(/[ap]m$/, '');
  let h;
  let m;
  const sep = body.match(/^(\d{1,2})[:.h](\d{0,2})$/);
  if (sep) {
    h = Number(sep[1]);
    m = sep[2] === '' ? 0 : Number(sep[2].length === 1 ? `${sep[2]}0` : sep[2]);
  } else if (/^\d{1,4}$/.test(body)) {
    if (body.length <= 2) { h = Number(body); m = 0; } else { h = Number(body.slice(0, -2)); m = Number(body.slice(-2)); }
  } else {
    return null;
  }
  if (pm && h < 12) h += 12;
  if (am && h === 12) h = 0;
  if (h === 24 && m === 0) h = 0;
  if (h > 23 || m > 59) return null;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

// Every time of day in `step`-minute steps: "00:00", "00:15", …
export function timeSteps(step = 15) {
  const out = [];
  for (let t = 0; t < 24 * 60; t += step) out.push(`${String(Math.floor(t / 60)).padStart(2, '0')}:${String(t % 60).padStart(2, '0')}`);
  return out;
}

// The step nearest a time, for scrolling the list to where you are.
export function nearestStep(value, step = 15) {
  const t = parseTime(value);
  if (!t) return null;
  const [h, m] = t.split(':').map(Number);
  const mins = (Math.round((h * 60 + m) / step) * step) % (24 * 60);
  return `${String(Math.floor(mins / 60)).padStart(2, '0')}:${String(mins % 60).padStart(2, '0')}`;
}
